export default __webpack_public_path__ + "static/media/Simhastha.7de9bbd1.jpg";